import React from 'react'
import style from './NoMatches.scss'

const NoMatches = () => {
  return (
    <label className={style['no-matches']}>
      No matches found
    </label>
  )
}

export default NoMatches
